import React from 'react';

import {TableMerchant} from '../../../helpers/Table/';
import {generateActionsList} from "./utils/generateActionsList";
import {columnsList} from "./constants/columnsList";
import {reportGenerationParams} from "./constants/reportGenerationParams";
import Caption from "../../../dumb/Caption/C";
import {Box} from "@material-ui/core";
import {apiV2PayByLinkList} from "../../../../api/merchant/payByLink";
import * as links from '../../../../constants/links';
import Button from '../../../dumb/Button/C';
import {
  pushLocation,
} from '../../../../router';
import handleDBItemData from './utils/handleDBItemData';
import {MerchantPageHeader} from "../../../helpers/Display";
import {BtnBlueFilled} from "../../../helpers/Buttons";

const getRowsFromServer = ({offset, limit, ...rest}) => {
  return apiV2PayByLinkList({offset, limit, ...rest}).then((res) => {
    res.list = res.list.map(handleDBItemData);
    return res;
  });
};

module.exports = () => {
  return (
    <>
      <MerchantPageHeader
        title="Pay by Link"
        rightBlock={(
          <Box maxWidth="19rem" width="100%">
            <BtnBlueFilled
              onClick={() => {
                pushLocation({
                  path: links.LINK_PBL_CREATE,
                });
              }}
              heightMedium
            >
              New payment link
            </BtnBlueFilled>
          </Box>
        )}
      />
      <Box width="100%" height="calc(100% - 50px)" minHeight="500px">
        <TableMerchant
          getDataFromServer={getRowsFromServer}
          report={reportGenerationParams}
          columns={columnsList}
          actions={(row, update) => (
            generateActionsList(row, update)
          )}
        />
      </Box>
    </>
  )
}
